<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Empresas</div>
            <div class="subTitulo">
              Visualize, edite e cadastre novas Empresas na plataforma.
            </div>
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="empresaForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Linha separadora -->
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>

        <!-- Abas Ativas / Inativas -->
        <div v-if="empresaForm" class="row mb-3">
          <div class="col-md-12">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  :class="{ active: abaStatus === 'ativas' }"
                  @click.prevent="changeAba('ativas')"
                >
                  Empresas ativas
                </a>
              </li>
              <li class="nav-item">
                <a
                  href="#"
                  class="nav-link"
                  :class="{ active: abaStatus === 'inativas' }"
                  @click.prevent="changeAba('inativas')"
                >
                  Empresas inativas
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Filtros -->
        <div v-if="empresaForm" class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="CNPJ" label-for="filter">
              <b-form-input id="filter" v-model="filter" type="text" />
            </b-form-group>
          </div>

          <div class="col-md-4">
            <b-form-group id="input-group-2" label="Tipo de Contrato" label-for="tipo-contrato">
              <b-form-select
                id="tipo-contrato"
                v-model="filtroTipoContrato"
                :options="[
                  { value: '', text: 'Todos' },
                  { value: 'mensal', text: 'Mensal' },
                  { value: 'anual', text: 'Anual' },
                  { value: 'creditos', text: 'Créditos' }
                ]"
              />
            </b-form-group>
          </div>

          <div class="col-md-2 mt-4 pt-1">
            <button class="btn btn-primary" @click="listandoByFilter">
              Pesquisar
            </button>
          </div>
        </div>
      </div>

      <div>
        <div v-if="empresaForm">
          <!-- Abas internas: Tabela / Mapa -->
          <div class="row mb-3">
            <div class="col-md-12">
              <ul class="nav nav-pills sub-tabs">
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link"
                    :class="{ active: viewTab === 'tabela' }"
                    @click.prevent="setViewTab('tabela')"
                  >
                    Tabela
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    href="#"
                    class="nav-link"
                    :class="{ active: viewTab === 'mapa' }"
                    @click.prevent="setViewTab('mapa')"
                  >
                    Mapa
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- VIEW: MAPA -->
          <div v-show="viewTab === 'mapa'" class="row mb-3">
            <div class="col-md-12">
              <div class="map-wrapper">
                <div class="map-header">
                  <div class="map-title">Mapa de Empresas</div>
                  <div class="map-subtitle">
                    Marcadores com latitude/longitude cadastrados. Total no mapa:
                    <b>{{ mapaPontosCount }}</b>
                  </div>
                </div>

                <div ref="mapaEmpresas" class="map-container"></div>
              </div>
            </div>
          </div>

          <!-- VIEW: TABELA -->
          <div v-show="viewTab === 'tabela'">
            <div class="row">
              <div class="col-md-12">
                <div class="float-right">
                  <div class="description found">
                    <b>Total de Registros: {{ rows }}</b>
                  </div>
                </div>
              </div>
            </div>

            <b-table
              striped
              hover
              responsive="sm"
              borderless
              bordered
              outlined
              small
              :items="empresa_sistema"
              :fields="empresaFields"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template #cell(nome)="row">
                <div>
                  <strong>{{ row.item.nome }}</strong><br />
                  <small>CNPJ: {{ row.item.cnpj }}</small><br />
                  <small>
                    {{ row.item.municipio ? row.item.municipio.nome : '-' }}-
                    {{ row.item.estado ? row.item.estado.sigla : '-' }}
                  </small>
                </div>
              </template>

              <template #cell(email)="row">
                <div style="display:flex; flex-direction:column; gap:5px">
                  <span>{{ row.item.email || 'E-mail não informado' }}</span>

                  <template v-if="row.item.telefone">
                    <a
                      :href="`https://wa.me/55${row.item.telefone.replace(/\\D/g, '')}`"
                      target="_blank"
                      title="Conversar no WhatsApp"
                      style="text-decoration:none; color:#25d366; display:flex; align-items:center; gap:5px;"
                    >
                      <i class="uil uil-whatsapp"></i>
                      {{ row.item.telefone }}
                    </a>
                  </template>
                  <template v-else>
                    <span>Telefone não informado</span>
                  </template>
                </div>
              </template>

              <template #cell(actions)="row">
                <div class="btn-group mb-2">
                  <b-dropdown
                    v-b-tooltip.hover
                    size="md"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    :title="abaStatus === 'ativas' ? 'Ações da empresa' : 'Ações da empresa inativa'"
                  >
                    <template #button-content>
                      <i class="uil uil-ellipsis-v"></i>
                    </template>

                    <b-dropdown-item @click="editRegister(row.item)">
                      Editar
                    </b-dropdown-item>

                    <b-dropdown-item v-if="abaStatus === 'ativas'" @click="gerarCobranca(row.item)">
                      Gerar cobrança
                    </b-dropdown-item>

                    <b-dropdown-item @click="modalDelete(row.item.id_empresa_sistema)">
                      {{ abaStatus === 'ativas' ? 'Inativar' : 'Ativar' }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              size="md"
              :total-rows="rows"
              :per-page="perPage"
            />
          </div>
        </div>

        <div v-else>
          <formEmpresa :empresa="empresaEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>

    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>
        Tem certeza que deseja
        {{ abaStatus === 'ativas' ? 'inativar' : 'ativar' }}
        esta empresa?
      </p>
      <template #modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <loading :active.sync="isLoading" color="#008e75" :can-cancel="true" />
  </Layout>
</template>

<script>
import Layout from "@layouts/main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import empresa_sistema from "@/src/services/empresa_sistema";
import billing from "@/src/services/billing";
import formEmpresa from "@/src/components/form-empresa-sistema";

// Leaflet
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// FULLSCREEN (use este pacote)
import "leaflet-fullscreen";
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";

// Corrige paths do ícone (webpack quebra sem isso)
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
});

export default {
  components: { Layout, Loading, formEmpresa },

  data() {
    return {
      empresaEdit: {},
      empresa_sistema: [],
      empresaForm: true,
      idUserDelete: "",
      modal: false,
      isLoading: true,
      filter: "",
      filtroTipoContrato: "",
      artPrimaria: "",
      nReceitasArt: "",
      artImpressao: "",
      abaStatus: "ativas",

      // sub-aba (tabela/mapa)
      viewTab: "tabela",

      empresaFields: [
        { key: "nome", label: "Nome" },
        { key: "email", label: "E-mail" },
        { key: "tipo_contrato", label: "Contrato" },
        { key: "responsavel", label: "Responsável" },
        { key: "actions", label: "" },
      ],
      currentPage: 1,
      perPage: 15,

      // MAPA
      mapa: null,
      markersLayer: null,
      mapaReady: false,
      mapaPontos: [],
    };
  },

  computed: {
    rows() {
      return this.empresa_sistema.length;
    },
    mapaPontosCount() {
      return this.mapaPontos && this.mapaPontos.length ? this.mapaPontos.length : 0;
    },
  },

  watch: {
    empresaForm(val) {
      if (val) {
        this.listandoByFilter();
      } else {
        this.destroyMapa();
      }
    },
  },

  mounted() {
    this.listandoByFilter();

    this.$root.$on("back", () => {
      this.empresaForm = true;
      this.empresaEdit = {};
    });
  },

  beforeDestroy() {
    this.destroyMapa();
  },

  methods: {
    setViewTab(tab) {
      if (this.viewTab === tab) return;
      this.viewTab = tab;

      if (tab === "mapa") {
        this.$nextTick(async () => {
          this.ensureMapa();
          try {
            await this.carregarMapa();
          } catch (e) {
            this.mapaPontos = [];
            this.renderMapaPontos([]);
          }
          this.invalidateMapa();
        });
      }
    },

    changeAba(status) {
      if (this.abaStatus === status) return;
      this.abaStatus = status;
      this.currentPage = 1;
      this.listandoByFilter();
    },

    async listandoByFilter() {
      const token = this.$store.state.auth.currentUser.token;
      this.isLoading = true;

      const filtros = {
        cnpj: this.filter || undefined,
        tipo_contrato: this.filtroTipoContrato || undefined,
        ativo: this.abaStatus === "ativas" ? 1 : 0,
      };

      try {
        const resposta = await empresa_sistema.findByName(token, filtros);
        this.empresa_sistema = resposta && resposta.data ? resposta.data : [];

        if (this.empresaForm && this.viewTab === "mapa") {
          await this.$nextTick();
          this.ensureMapa();
          await this.carregarMapa();
          this.invalidateMapa();
        }
      } catch (e) {
        this.empresa_sistema = [];
        this.mapaPontos = [];
        this.renderMapaPontos([]);
      } finally {
        this.isLoading = false;
      }
    },

    abrirForm() {
      if (this.empresaForm === true) {
        this.empresaForm = false;
      } else {
        this.empresaForm = true;
        this.empresaEdit = {};
      }
    },

    editRegister(empresa) {
      this.empresaEdit = empresa;
      this.empresaForm = false;
    },

    modalDelete(item) {
      this.modal = true;
      this.idUserDelete = item;
    },

    async handleDelete() {
      const token = this.$store.state.auth.currentUser.token;
      const acaoTexto = this.abaStatus === "ativas" ? "inativada" : "ativada";

      try {
        await empresa_sistema.deleteEmpresa(token, this.idUserDelete);
        await this.listandoByFilter();

        this.$bvToast.toast(`Empresa ${acaoTexto} com sucesso!`, {
          variant: "success",
          solid: true,
          noCloseButton: true,
          toaster: "b-toaster-top-center",
        });
      } catch (e) {
        this.$bvToast.toast(
          "Ocorreu um erro ao atualizar o status da empresa. Verifique se o item está sendo utilizado em outro lugar.",
          {
            variant: "danger",
            solid: false,
            noCloseButton: true,
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.idUserDelete = null;
        this.modal = false;
      }
    },

    async gerarCobranca(empresa) {
      const token = this.$store.state.auth.currentUser.token;

      const confirma = window.confirm(
        `Gerar cobrança para a empresa "${empresa.nome}" e enviar por e-mail?`
      );
      if (!confirma) return;

      try {
        this.isLoading = true;
        await billing.gerarCobranca(token, empresa.id_empresa_sistema);

        this.$bvToast.toast("Cobrança gerada e documentos enviados por e-mail com sucesso.", {
          variant: "success",
          solid: true,
          noCloseButton: true,
          toaster: "b-toaster-top-center",
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$bvToast.toast("Erro ao gerar cobrança. Verifique os dados da empresa e tente novamente.", {
          variant: "danger",
          solid: true,
          noCloseButton: true,
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.isLoading = false;
      }
    },

    // =====================
    // ====== MAPA =========
    // =====================
    ensureMapa() {
      if (this.mapaReady) return;

      const el = this.$refs.mapaEmpresas;
      if (!el) return;

      this.destroyMapa();

      this.mapa = L.map(el, { scrollWheelZoom: true }).setView([-14.235, -51.9253], 4);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.mapa);

      this.markersLayer = L.layerGroup().addTo(this.mapa);

      // Fullscreen control (botão no próprio mapa)
      if (L.control && L.control.fullscreen) {
        L.control.fullscreen({ position: "topleft" }).addTo(this.mapa);
      } else {
        // eslint-disable-next-line no-console
        console.warn("leaflet-fullscreen não carregou: L.control.fullscreen não existe.");
      }

      this.mapaReady = true;
    },

    invalidateMapa() {
      if (!this.mapa) return;
      setTimeout(() => {
        try {
          this.mapa.invalidateSize();
        } catch (e) {}
      }, 80);
    },

    destroyMapa() {
      if (this.mapa) {
        try {
          this.mapa.remove();
        } catch (e) {}
      }
      this.mapa = null;
      this.markersLayer = null;
      this.mapaReady = false;
    },

    async carregarMapa() {
      if (!this.empresaForm) return;
      if (this.viewTab !== "mapa") return;

      this.ensureMapa();
      if (!this.mapaReady) return;

      const token = this.$store.state.auth.currentUser.token;
      const params = { ativo: this.abaStatus === "ativas" ? 1 : 0 };

      const resp = await empresa_sistema.getMapaEnderecos(token, params);

      const raw = resp && Array.isArray(resp.data) ? resp.data : [];
      const pontos = raw
        .map((p) => {
          const lat = typeof p.latitude === "number" ? p.latitude : Number(p.latitude);
          const lng = typeof p.longitude === "number" ? p.longitude : Number(p.longitude);

          return {
            id: p.id,
            nome: p.nome,
            cnpj: p.cnpj,
            ativo: !!p.ativo,
            enderecoCompleto: p.enderecoCompleto,
            municipio: p.municipio,
            uf: p.uf,
            latitude: lat,
            longitude: lng,
          };
        })
        .filter((p) => isFinite(p.latitude) && isFinite(p.longitude));

      this.mapaPontos = pontos;
      this.renderMapaPontos(pontos);
    },

    renderMapaPontos(pontos) {
      if (!this.mapaReady || !this.markersLayer) return;

      this.markersLayer.clearLayers();
      if (!pontos || !pontos.length) return;

      const bounds = [];

      for (let i = 0; i < pontos.length; i++) {
        const p = pontos[i];

        const popupHtml =
          '<div style="min-width:220px">' +
          '<div style="font-weight:600; margin-bottom:4px;">' +
          this.escapeHtml(p.nome || "-") +
          "</div>" +
          "<div><small><b>CNPJ:</b> " +
          this.escapeHtml(p.cnpj || "-") +
          "</small></div>" +
          '<div style="margin-top:6px;"><small>' +
          this.escapeHtml(p.enderecoCompleto || "-") +
          "</small></div>" +
          '<div style="margin-top:6px;"><small><b>' +
          this.escapeHtml(p.municipio || "-") +
          "/" +
          this.escapeHtml(p.uf || "-") +
          "</b></small></div>" +
          "</div>";

        L.marker([p.latitude, p.longitude]).bindPopup(popupHtml).addTo(this.markersLayer);
        bounds.push([p.latitude, p.longitude]);
      }

      if (bounds.length) {
        this.mapa.fitBounds(bounds, { padding: [30, 30] });
      }
    },

    escapeHtml(str) {
      const s = String(str === null || str === undefined ? "" : str);
      return s
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
  },
};
</script>

<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subTitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* Sub-abas (Tabela/Mapa) */
  .sub-tabs {
    margin-top: 10px;
  }

  /* ===== MAPA ===== */
  .map-wrapper {
    border: 1px solid #edeff4;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
  }

  .map-header {
    padding: 12px 14px;
    border-bottom: 1px solid #edeff4;
  }

  .map-title {
    font-weight: 700;
    color: #008e75;
  }

  .map-subtitle {
    font-size: 12px;
    color: #6c757d;
  }

  /* aumenta o tamanho */
  .map-container {
    width: 100%;
    height: 70vh;
    min-height: 520px;
  }
}
</style>
